export default __webpack_public_path__ + "static/media/fabric.d5cd083b.svg";